module.exports = __webpack_public_path__ + "static/img/icon-pin-hover.74f7cf4d.svg";